// @ts-check

/* eslint-disable perfectionist/sort-objects -- keys are sorted semantically */
export default {
  'mobile-sm': '20rem',
  'mobile-md': '23.4375rem',
  mobile: '26.5625rem',
  tablet: '48rem',
  desktop: '64rem',
  'desktop-lg': '90rem',
}
